export function makeModifierClassname(styles: Record<string, string>, prefix: string) {
    const makeClassName = (...components: string[]) => components.join('_');

    function getModifierClassname(modifier: string, value?: unknown): string {
        if (value === true) {
            return styles[makeClassName(prefix, modifier)] || '';
        }

        if (value !== undefined && value !== null) {
            return styles[makeClassName(prefix, modifier, String(value))] || '';
        }

        return '';
    }

    getModifierClassname.className = styles[prefix] || '';

    return getModifierClassname;
}
